import { useState } from 'react';
import SelectWhatsappModal from '../../SelectWhatsappModal';
export default function FinalCTA({ logoSrc = '/boggler-logo.webp', waitlistUrl = '#' }) {
  const [showWhatsAppModal, setShowWhatsAppModal] = useState(false);


  return (
    <section className="py-20 px-6 bg-gradient-to-br from-boggler-teal to-boggler-blue relative overflow-hidden">
      <SelectWhatsappModal show={showWhatsAppModal} onClose={() => setShowWhatsAppModal(false)} />
      <div className="absolute inset-0 opacity-10">
        <svg className="w-full h-full" viewBox="0 0 100 100" preserveAspectRatio="none">
          <defs>
            <pattern id="grid" width="10" height="10" patternUnits="userSpaceOnUse">
              <path d="M 10 0 L 0 0 0 10" fill="none" stroke="white" strokeWidth="0.5"/>
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <div className="mb-6">
          <img src={logoSrc} alt="Boggler Trails" className="w-16 h-16 mx-auto opacity-90" />
        </div>

        <h2 className="lucky-font text-4xl md:text-6xl text-white mb-4">
          Boggler Trails
        </h2>
        <p className="text-2xl text-white opacity-90 mb-2 font-lucky">
          Coming Soon
        </p>
        <p className="text-lg md:text-xl text-white opacity-80 mb-8 font-lato max-w-2xl mx-auto">
          Personal video journals from guides who know you.
          Delivered to your TV. Join the waitlist.
        </p>

        <div className="flex flex-col justify-center sm:flex-row gap-3 max-w-md mx-auto mb-8">
          <button
            onClick={() => setShowWhatsAppModal(true)}
            className="bg-orange-cta text-white px-8 py-4 rounded-full font-montserrat font-semibold shadow-boggler btn-hover-lift whitespace-nowrap"
          >
            Join Waitlist
          </button>
        </div>


        <div className="flex flex-wrap justify-center gap-8 text-white mt-8">
          {['Personal video journals', 'Watch on Apple TV', 'Subscription access'].map((text, i) => (
            <div key={i} className="flex items-center gap-2">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
                <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
              </svg>
              <span className="font-lato text-sm">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
